"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuSectionsQuery = void 0;
const client_1 = require("@apollo/client");
exports.menuSectionsQuery = client_1.gql `
  query MenuSections {
    menuSections {
      id
      name
      position
    }
  }
`;
//# sourceMappingURL=menuSections.js.map